export const SCRIPTS_SOURCES = {
  DEVICE_MANAGEMENT: '/deviceManagement/deviceManagementScripts', // used by windows platforms
  DEVICE_SHELL: '/deviceManagement/deviceShellScripts', // used by macos platforms
  CONFIGURATION_POLICIES: '/deviceManagement/configurationPolicies', // used by linux platforms
}
